import type { SubscriptionDetails } from 'src/API'
import { restApi } from 'src/redux/api/rest/restApi'

export const subscriptionApi = restApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchSubscriptionStatus: builder.query({
			query: (id: string) => ({
				apiName: 'subscriptionApi',
				method: 'GET',
				path: `/subscription/${id}`,
			}),
			providesTags: (_result, _error, id) => [
				{ type: 'Subscription', id },
			],
		}),
		fetchCustomerData: builder.query({
			query: (tenantId: string) => ({
				apiName: 'subscriptionApi',
				method: 'GET',
				path: `/subscription/customer/${tenantId}`,
			}),
			providesTags: (_result, _error, tenantId) => [
				{ type: 'Subscription', id: tenantId },
			],
			transformResponse: (response: {
				subscriptionData: SubscriptionDetails
			}) => {
				const { subscriptionData } = response
				return { subscriptionData } as {
					subscriptionData: SubscriptionDetails
				}
			},
		}),
		createStripeCustomer: builder.mutation({
			query: (data: {
				email: string
				tenantId: string
				name: string
				phoneNumber?: string | null
				preferred_locales: string[]
			}) => ({
				apiName: 'subscriptionApi',
				path: '/subscription/create',
				method: 'POST',
				myInit: { body: data },
			}),
			invalidatesTags: [{ type: 'Subscription', id: 'LIST' }],
		}),
		createCheckoutUrl: builder.mutation({
			query: (data: {
				tenantId: string
				stripeId: string
				productId: string
				domainUrl: string
				locale?: string
			}) => ({
				apiName: 'subscriptionApi',
				path: '/subscription/checkout',
				method: 'POST',
				myInit: { body: data },
			}),
			invalidatesTags: [{ type: 'Subscription', id: 'LIST' }],
		}),
		createPortalSession: builder.mutation({
			query: (data: {
				stripeId: string
				domainUrl: string
				locale?: string
			}) => ({
				apiName: 'subscriptionApi',
				path: '/subscription/portal',
				method: 'POST',
				myInit: { body: data },
			}),
		}),
		fetchBuildInfo: builder.query({
			query: () => ({
				apiName: 'subscriptionApi',
				method: 'GET',
				path: '/subscription/build-info',
			}),
			// Don't cache this data - always fetch fresh
			keepUnusedDataFor: 0,
		}),
	}),
	overrideExisting: false,
})

export const {
	useFetchSubscriptionStatusQuery,
	useFetchCustomerDataQuery,
	useFetchBuildInfoQuery,
	useCreateStripeCustomerMutation,
	useCreateCheckoutUrlMutation,
	useCreatePortalSessionMutation,
} = subscriptionApi
